export default "__VITE_ASSET__6q2KV7ca__"